// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.account-change-password-outer-container {
    width: 50rem;
}

.account-change-password-inner-container {
}

.password-text-container {
    display: flex;
}

.validity-container > svg {
    position: absolute;
    opacity: 0;
    transition: opacity 0.3s ease;
}

    .validity-container > svg.password-isinvalid {
        fill: var(--color-error);
    }

    .validity-container > svg.password-isvalid {
        fill: var(--color-success);
    }

.validity-container.valid > svg.password-isvalid {
    opacity: 1;
}

.validity-container.invalid > svg.password-isinvalid {
    opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/Account/css/AccountChangePassword.css"],"names":[],"mappings":"AAEA;IACI,YAAY;AAChB;;AAEA;AACA;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,6BAA6B;AACjC;;IAEI;QACI,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;IAC9B;;AAEJ;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd","sourcesContent":["@import '../../css/App.css';\r\n\r\n.account-change-password-outer-container {\r\n    width: 50rem;\r\n}\r\n\r\n.account-change-password-inner-container {\r\n}\r\n\r\n.password-text-container {\r\n    display: flex;\r\n}\r\n\r\n.validity-container > svg {\r\n    position: absolute;\r\n    opacity: 0;\r\n    transition: opacity 0.3s ease;\r\n}\r\n\r\n    .validity-container > svg.password-isinvalid {\r\n        fill: var(--color-error);\r\n    }\r\n\r\n    .validity-container > svg.password-isvalid {\r\n        fill: var(--color-success);\r\n    }\r\n\r\n.validity-container.valid > svg.password-isvalid {\r\n    opacity: 1;\r\n}\r\n\r\n.validity-container.invalid > svg.password-isinvalid {\r\n    opacity: 1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
